const baseUrl = "https://addisionrosebk.marmeto.com"; //"https://printfit.ngrok.io";

let userToken = null;
if (!!localStorage.getItem("login")) {

  userToken = localStorage.getItem("login");
}

export { baseUrl, userToken };
